import { usePlatform } from "@/composables/platform";

export default defineNuxtRouteMiddleware((to) => {
    const { ANDROID_BLOCKED } = useRuntimeConfig().public;
    const { isAndroid } = usePlatform();
    const $router = useRouter();
    if (ANDROID_BLOCKED && isAndroid.value && to.name !== "android") {
        $router.replace("/android");
    } else if ((!ANDROID_BLOCKED || !isAndroid.value) && to.name === "android") {
        $router.replace("/");
    }
});
